import { createPluginOptions } from "../create-plugin-options";

export const defaultVibEventOptions = createPluginOptions()({
	oplVisible: false,
});

export type VibEventOptions = typeof defaultVibEventOptions;
